module.exports = __webpack_public_path__ + "super-adults-7cf36a1d8dedf3057caff334d0623f2d.png";


/*****************
 ** WEBPACK FOOTER
 ** ../app/Components/Banner/super-adults.png
 ** module id = 473
 ** module chunks = 0
 **/